import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemOrganizationsSpotlightHeading: {
		id: 'spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-heading',
		defaultMessage: 'Organizations relocated',
		description: 'Heading for the new spotlight for the item organizations navigation item',
	},
	itemOrganizationsSpotlightBody: {
		id: 'spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-body',
		defaultMessage: "We've moved organizations from your Customers page.",
		description: 'Body text for the new spotlight for the item organizations navigation item',
	},
	itemOrganizationsSpotlightConfirmButton: {
		id: 'spa-apps-sidebar-servicedesk.common.ui.customer-support-management-section.item-organizations-spotlight-confirm-button',
		defaultMessage: 'Got it',
		description:
			'Confirm button text for the new spotlight for the item organizations navigation item',
	},
});
